import { type MailboxInfo, getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { BizChatCompositeKey, WindowKey } from 'owa-bizchat-types';

export const getBizchatLoadedKey = (
    mailboxInfo: MailboxInfo,
    windowKey: WindowKey
): BizChatCompositeKey => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return `${accountKey}_${windowKey}`;
};
